<template>
  <component
    :is="tag"
    :class="[
      'main-menu-item',
      { 'main-menu-item--compact': compact },
      { 'main-menu-item--active': active }
    ]"
    v-bind="$attrs"
  >
    <div class="main-menu-item__content">
      <slot name="icon"></slot>
      <span class="main-menu-item__text">
        <slot></slot>
      </span>
    </div>
  </component>
</template>

<script setup lang="ts">
defineProps({
  compact: {
    type: Boolean,
    default: false
  },
  active: {
    type: Boolean,
    default: false
  },
  tag: {
    type: String,
    default: 'a'
  }
})
</script>

<style scoped>
.main-menu-item {
  display: flex;
  align-items: center;
  padding: 8px 8px;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  width: 100%;
  min-height: 36px;
}

.main-menu-item__content {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
}

.main-menu-item__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 1;
  transition: opacity 0.3s ease;
  color: var(--layout-sidebar-text);
  font-family: var(--font-outfit);
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

/* Mode compact */
.main-menu-item--compact {
  padding: 8px;
  justify-content: center;
}

.main-menu-item--compact .main-menu-item__text {
  opacity: 0;
  width: 0;
}

/* États */
.main-menu-item:hover {
  background: var(--layout-sidebar-bg-hover);
}

.main-menu-item:hover .main-menu-item__text {
  color: var(--layout-sidebar-text-hover);
}

.main-menu-item--active {
  background: var(--layout-sidebar-bg-active);
}

.main-menu-item--active:hover {
  background: var(--layout-sidebar-bg-active);
}

.main-menu-item--active .main-menu-item__text {
  color: var(--layout-sidebar-text-active);
  font-weight: 700;
}

/* Style des icônes */
.main-menu-item :deep(svg) {
  color: var(--layout-sidebar-text);
  min-width: 20px !important;
}

.main-menu-item:hover :deep(svg) {
  color: var(--layout-sidebar-text-hover);
}

.main-menu-item--active :deep(svg) {
  color: var(--layout-sidebar-text-active);
}
</style>
